








































































import { Component, Vue } from 'vue-property-decorator'
import BreadCrumbs from '@/components/BreadCrumbs.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import DialogConfirm from '@/components/DialogConfirm.vue'
import { User } from '@/utils/Interfaces'
import { approveUser, denyUser, getUsersForApproval } from '@/utils/ApiServices'
import { handle } from '@/utils/ErrorHandling'
import { formatDateTime, normalize } from '@/utils/CommonUtils'

@Component({
  components: {
    BreadCrumbs,
    SectionTitle,
    DialogConfirm,
  }
})
export default class DuyetNguoiDung extends Vue {
  breadcrumbs = [
    {
      text: 'Trang chủ',
      to: { name: 'Home' },
    },
    {
      text: 'Duyệt người dùng',
      to: { name: 'DuyetNguoiDung' },
    },
  ]

  get isSuperUser () {
    return this.$store.getters.isSuperUser
  }

  approveText = 'Đã duyệt'
  denyText = 'Chưa duyệt'
  noDataText = 'Không có người dùng nào'

  /**
   * Get all users
   */
  fetchingUsers = false
  users: Array<User> = []

  mounted () {
    if (!this.isSuperUser) {
      this.$router.push({ name: 'TrangCaNhan' })
    }

    this.fetchingUsers = true
    getUsersForApproval()
      .then(response => {
        this.users = response.data
      })
      .catch(handle)
      .finally(() => {
        this.fetchingUsers = false
      })
  }

  /**
   * Create datatable
   */
  get tableRows () {
    return this.users.map(user => {
      return {
        email: user.email,
        fullname: user.fullname,
        date_joined: formatDateTime(user.date_joined),
        is_staff: user.is_staff ? this.approveText : this.denyText,
        is_superuser: user.is_superuser,
      }
    })
  }

  get tableHeaders () {
    return [
      {
        text: 'Email',
        value: 'email',
      },
      {
        text: 'Họ tên',
        value: 'fullname',
      },
      {
        text: 'Ngày tham gia',
        value: 'date_joined',
      },
      {
        text: 'Trạng thái',
        value: 'is_staff',
        align: 'center',
        sortable: false,
      },
      {
        value: 'action',
        align: 'center',
        sortable: false,
        filterable: false,
        width: 133,
      },
    ]
  }

  searchKeyword = ''
  isStaffOnly = false

  filterEmailAndName (value: unknown, search: string | null) {
    if (value === null || search === null || typeof value !== 'string') {
      return false
    }
    const normalizedValue = normalize(value)
    const normalizedSearch = normalize(search)
    return normalizedValue.includes(normalizedSearch)
  }

  /**
   * Approve / deny user
   */

  userToApprove: User = new User
  userToDeny: User = new User

  getUser (email: User['email']) {
    return this.users.find(user => user.email === email) || new User
  }

  approveDialog = false
  denyDialog = false

  confirmApprove (email: User['email']) {
    this.userToApprove = this.getUser(email)
    this.approveDialog = true
  }

  confirmDeny (email: User['email']) {
    this.userToDeny = this.getUser(email)
    this.denyDialog = true
  }

  approveUser () {
    approveUser(this.userToApprove.id)
      .then(() => {
        const user = this.users.find(user => user.id === this.userToApprove.id)
        if (user !== undefined) {
          user.is_staff = true
          this.$store.dispatch('alertMessage', `Duyệt người dùng ${user.email} thành công.`)
        }
        this.approveDialog = false
      })
      .catch(handle)
  }

  denyUser () {
    denyUser(this.userToDeny.id)
      .then(() => {
        const user = this.users.find(user => user.id === this.userToDeny.id)
        if (user !== undefined) {
          user.is_staff = false
          this.$store.dispatch('alertMessage', `Hủy duyệt người dùng ${user.email} thành công.`)
        }
        this.denyDialog = false
      })
      .catch(handle)
  }
}
